<template>
	<v-container class="welcome-page">
		<h1 class="welcome-page__title mb-10">Welcome!</h1>
		<v-btn
			type="button"
			class="login-button"
			@click="navigateToLoginPage"
			v-if="userLoginCategories.length > 0 && !isLoading"
		>
			{{ loginButtonName }}
		</v-btn>

		<a
			v-if="userRegisterCategories.length > 0"
			class="create-account-link"
			@click="navigateToRegisterPage"
		>
			{{ signupButtonName }}
		</a>
	</v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import TokenService from '@/services/token.service'
import Dwh from '@/mixins/Dwh'
import LocalStorageService from '@/services/local-storage.service'
import menuList from "@/utils/menuList";

export default {
	name: 'LoginPage',
	mixins: [Dwh, menuList],
	data: () => ({}),
	computed: {
		...mapGetters('settings', ['login']),
		...mapGetters('auth', [
			'UserLogInCategories',
			'userRegistrationCategories',
			'isAuthenticated',
      'isLoading'
		]),
		initRoute() {
			return LocalStorageService.get('initRoute') || null
		},
		userLoginCategories() {
			return this.UserLogInCategories || []
		},

		userRegisterCategories() {
			return this.userRegistrationCategories || []
		},
		hostName() {
			return window.location.hostname || 'localhost'
		},
		protocol() {
			return window.location.protocol || 'http'
		},
		deviceId() {
			return TokenService.getDeviceIdFromStorage()
		},
		externalLoginUrl() {
			return `${this.protocol}//${this.hostName}/oauth?device-id=${this.deviceId}&redirect_url=${this.protocol}//${this.hostName}${process.env.VUE_APP_PUBLIC_PATH}oauth2-callback`
		},
		signupButtonName() {
			const { signup_ss_button: signUpButtonName } = this.login || {}

			return signUpButtonName || 'Create Account'
		},
		loginButtonName() {
			const { login_ss_button: logInButtonName } = this.login || {}

			return logInButtonName || 'Login to your Account'
		},
	},
	methods: {
		...mapActions('auth', ['getLogInCategory', 'getRegisterCategories']),
		navigateToLoginPage() {
			const { external_login: externalLogin } = this.login || {}
			const isUserPreferExternalLogin = !!externalLogin
			const objectCategory = this.userLoginCategories[0]
			const user_category_id = objectCategory.user_category_id
			const slug = objectCategory.slug
			if (this.isAuthenticated && isUserPreferExternalLogin) {
				this.$router.push(this.initRoute ? this.initRoute : this.getLogoUrl)
				LocalStorageService.remove('initRoute')
				return
			}

			this.sendTrigger({
				category: 'App Start',
				action: 'login_start',
				module: 'App Launch',
				title: this.loginButtonName,
			})

			if (
				this.userLoginCategories.length <= 1 &&
				objectCategory.login_settings?.external_login === 1
			) {
				window.location.href = `${
					this.externalLoginUrl
				}&user_category_id=${encodeURIComponent(user_category_id)}`
			} else {
				if (this.userLoginCategories.length === 1) {
					const deepUpl = objectCategory.login_settings.login_url.replace(
						/^[^:]+:\/\/\/*/,
						''
					)
					window.location.href = `${
						window.location.origin
					}/webapp/auth/${deepUpl}?slug=${encodeURIComponent(
						slug
					)}&user_category_id=${encodeURIComponent(user_category_id)}`
					return
				}
				this.$router.push({ name: 'role-selection', query: { source: 'login' } })
			}
		},
		navigateToRegisterPage() {
			if (this.userRegisterCategories.length === 1) {
				const objectCategory = this.userRegisterCategories[0]
				const slug = objectCategory.slug
				if (
					slug === 'user' &&
					objectCategory.registration_settings?.external_registration === 1
				) {
					window.location.href = objectCategory.registration_settings.registration_url
					return
				}
				const user_category_id = objectCategory.user_category_id
				const deepUpl = objectCategory.registration_settings.registration_url.replace(
					/^[^:]+:\/\/\/*/,
					''
				)
				window.location.href = `${
					window.location.origin
				}/webapp/auth/${deepUpl}?slug=${encodeURIComponent(
					slug
				)}&user_category_id=${encodeURIComponent(user_category_id)}`
				return
			}
			this.$router.push({ name: 'role-selection', query: { source: 'register' } })
		},
	},
	created() {
		this.getLogInCategory()
		this.getRegisterCategories()
	},
}
</script>

<style lang="scss">
.welcome-page {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	height: 100%;
	width: 300px;
	margin-left: 10%;
	margin-bottom: 132px;
	@media (max-width: 800px) {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		height: 100%;
		width: 100%;
		margin-left: 0;
		margin-bottom: 0;
	}
	&__title {
		color: var(--welcome-button-signup-color);
		font-size: 36px;
		font-family: Montserrat, sans-serif;
		font-weight: bold;
	}
}

.logo-image {
	width: 40%;
}

.welcome-page .v-btn.login-button {
	background-color: var(--welcome-button-login-background) !important;
	color: var(--welcome-button-login-color) !important;
	border-radius: 8px;
	height: 50px !important;
	font-family: Montserrat, sans-serif;
	font-weight: bold;
	width: 320px;
	text-transform: none;
}

.login-button span {
	font-size: 16px;
}

.create-account-link {
	font-size: 18px;
	font-family: Montserrat, sans-serif;
	font-weight: bold;
	color: var(--welcome-button-signup-color) !important;
	margin-top: 40px;
	text-decoration: underline;
	cursor: default;
}

.terms-of-use {
	a {
		color: var(--link) !important;
	}
}
</style>
